// DATA
export const getNewsAggregations = state => state.news.getIn(['aggregations', 'data'])
export const getNewsAggregationsTimeline = state => getNewsAggregations(state).get('timeline')
export const getNewsAggregationsTimelineInterval = state => getNewsAggregations(state).getIn(['timeline', 0, 'interval'])

// UI
export const getNewsAggregationsUi = state => state.news.getIn(['aggregations', 'ui'])
export const getNewsAggregationsAggregationValue = state => getNewsAggregationsUi(state).get('aggregationValue')
